import _ from '@sparta.global.vendors/lodash';
import $ from '@sparta.global.vendors/jquery';
import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';
import workflowUtility from '@sparta.digital-mortgage-application.utilities/workflow-utility/dist/es6.js';
import Handlebars from '@sparta.global.vendors/handlebars';
import { curve } from '@sparta.digital-mortgage-application.helpers/digital-mortgage-application-helper/dist/es6.js';
import { picture } from '@sparta.global.helpers/picture-helper/dist/es6.js';
import { circleButton } from '@sparta.global.helpers/circle-button-helper/dist/es6.js';
import { button } from '@sparta.global.helpers/button-helper/dist/es6.js';
import { svgHelper } from '@sparta.global.helpers/svg-helper/dist/es6.js';

const Template = Handlebars.template({"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"row small-collapse\" id=\"chapterListHamburger\">\r\n          <div class=\"column small-8 medium-6 large-3 small-centered chapter-list-container place-hamburger\">\r\n            <div class=\"lines-button-wrapper\">\r\n              "
    + ((stack1 = (lookupProperty(helpers,"circleButton")||(depth0 && lookupProperty(depth0,"circleButton"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"menuButton") : depth0),{"name":"circleButton","hash":{},"data":data,"loc":{"start":{"line":19,"column":14},"end":{"line":19,"column":43}}})) != null ? stack1 : "")
    + "\r\n            </div>\r\n            <div class=\"chapter-list-wrapper closed\">\r\n              <ol class=\"chapter-list\">\r\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"chapters") : depth0),{"name":"each","hash":{},"fn":container.program(2, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":23,"column":16},"end":{"line":39,"column":25}}})) != null ? stack1 : "")
    + "              </ol>\r\n            </div>\r\n          </div>\r\n        </div>\r\n";
},"2":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"name") : depth0),{"name":"if","hash":{},"fn":container.program(3, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":24,"column":18},"end":{"line":38,"column":25}}})) != null ? stack1 : "");
},"3":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "                    <li class=\"chapter-list-item\" "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"number") : depth0),{"name":"if","hash":{},"fn":container.program(4, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":25,"column":50},"end":{"line":25,"column":106}}})) != null ? stack1 : "")
    + ">\r\n                      <div class=\"chapter-number-wrapper\">\r\n                        <div class=\"success-icon hide\">"
    + ((stack1 = (lookupProperty(helpers,"svgHelper")||(depth0 && lookupProperty(depth0,"svgHelper"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depths[1] != null ? lookupProperty(depths[1],"successIcon") : depths[1]),{"name":"svgHelper","hash":{},"data":data,"loc":{"start":{"line":27,"column":55},"end":{"line":27,"column":85}}})) != null ? stack1 : "")
    + "</div>\r\n                        <div class=\"inactive-number-icon\">"
    + ((stack1 = (lookupProperty(helpers,"svgHelper")||(depth0 && lookupProperty(depth0,"svgHelper"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"inactiveNumberIcon") : depth0),{"name":"svgHelper","hash":{},"data":data,"loc":{"start":{"line":28,"column":58},"end":{"line":28,"column":97}}})) != null ? stack1 : "")
    + "</div>\r\n                        <div class=\"active-number-icon hide\">"
    + ((stack1 = (lookupProperty(helpers,"svgHelper")||(depth0 && lookupProperty(depth0,"svgHelper"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"activeNumberIcon") : depth0),{"name":"svgHelper","hash":{},"data":data,"loc":{"start":{"line":29,"column":61},"end":{"line":29,"column":98}}})) != null ? stack1 : "")
    + "</div>\r\n                      </div>\r\n                      <div class=\"chapter-name body-small\">\r\n                        "
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"name") : depth0), depth0))
    + "\r\n                        <span class=\"ada-hidden chapter-in-progress-copy hide\">"
    + container.escapeExpression(container.lambda(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"completionIndicators") : depths[1])) != null ? lookupProperty(stack1,"inProgress") : stack1), depth0))
    + "</span>\r\n                        <span class=\"ada-hidden chapter-not-completed-copy\">"
    + container.escapeExpression(container.lambda(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"completionIndicators") : depths[1])) != null ? lookupProperty(stack1,"notCompleted") : stack1), depth0))
    + "</span>\r\n                      </div>\r\n                      <div class=\"chapter-name-link body-small hide\"> "
    + ((stack1 = (lookupProperty(helpers,"button")||(depth0 && lookupProperty(depth0,"button"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"menuItem") : depth0),{"name":"button","hash":{},"data":data,"loc":{"start":{"line":36,"column":70},"end":{"line":36,"column":96}}})) != null ? stack1 : "")
    + "</div>\r\n                    </li>\r\n";
},"4":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " data-mount=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"number") : depth0), depth0))
    + "\" ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\r\n<section class=\"chapter-container-module\">\r\n\r\n  <div class=\"row small-collapse full-width-row dma-layout hide\" data-dma-layout=\"chapter-section-layout\">\r\n    <div class=\"column small-12\">\r\n\r\n"
    + ((stack1 = lookupProperty(helpers,"with").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"copy") : depth0)) != null ? lookupProperty(stack1,"chapterList") : stack1),{"name":"with","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":15,"column":6},"end":{"line":44,"column":15}}})) != null ? stack1 : "")
    + "\r\n      <div class=\"row small-collapse\">\r\n        <div class=\"column small-12 small-centered main-container\">\r\n          <div class=\"main-content dma-modules\">\r\n            <div class=\"hide\">\r\n              "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"children") : depth0)) != null ? lookupProperty(stack1,"bodyContentWithTilesModule") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n              "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"children") : depth0)) != null ? lookupProperty(stack1,"formsModule") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n              "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"children") : depth0)) != null ? lookupProperty(stack1,"offRampModule") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n            </div>\r\n            <div class=\"current-view\"></div>\r\n            <div class=\"hide-show-modal\" style=\"display: none\"></div>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"row small-collapse dma-layout hide\" data-dma-layout=\"loading-screen-layout\">\r\n    <div class=\"small-12 column\">\r\n      "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"children") : depth0)) != null ? lookupProperty(stack1,"loadingScreenModule") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n    </div>\r\n  </div>\r\n\r\n  <div class=\"row small-collapse dma-layout hide\" data-dma-layout=\"assumptions-loan-layout\">\r\n    <div class=\"small-12 column\">\r\n      "
    + ((stack1 = container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"children") : depth0)) != null ? lookupProperty(stack1,"assumptionsModule") : stack1), depth0)) != null ? stack1 : "")
    + "\r\n    </div>\r\n  </div>\r\n\r\n</section>\r\n\r\n<div id=\"pageWaitingScreen\" class=\"hide\">\r\n  <div id=\"waitScreenContent\" class=\"wait-screen-content\">\r\n    <input type=\"hidden\" id=\"spinnerFlagscapeImageUrl\" value=\""
    + container.escapeExpression(container.lambda(((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"copy") : depth0)) != null ? lookupProperty(stack1,"spinnerFlagscpeUrl") : stack1)) != null ? lookupProperty(stack1,"src") : stack1), depth0))
    + "\" />\r\n    <span class=\"spinner-container\"></span>\r\n    <div class=\"additional-content trap-focus-div\">\r\n      <div class=\"row\">\r\n        <div class=\"column small-10 medium-6 small-centered\">\r\n          <div class=\"heading\" data-font=\"cnx-regular\"></div>\r\n        </div>\r\n        <div class=\"column small-10 medium-6 small-centered\">\r\n          <div class=\"body\" data-font=\"cnx-regular\"></div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n  </div>\r\n</div>";
},"useData":true,"useDepths":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.digital-mortgage-application.modules/site-specific-dme-chapter-container-module",
  "version": "2.0.1",
  "id": "siteSpecificDmeChapterContainerModule",
  "containerID": "digitalMortgageApplicationSiteSpecificDmeChapterContainerModule",
  "moduleName": "digital-mortgage-application-site-specific-dme-chapter-container-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "site-specific-dme-chapter-container-module",
  "data": {
    "init": "chapterContainerModuleJS",
    "options": {
      "copy": "{{json copy}}"
    }
  },
  "moduleParams": [],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {
        curve,
        picture,
        circleButton,
        button,
        svgHelper
      },
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {
    curve,
    picture,
    circleButton,
    button,
    svgHelper
  },
  "dependencies": {
    "@sparta.digital-mortgage-application.helpers/digital-mortgage-application-helper": "^2.0.0",
    "@sparta.digital-mortgage-application.utilities/workflow-utility": "^2.0.0",
    "@sparta.global.helpers/circle-button-helper": "^1.0.0",
    "@sparta.global.helpers/button-helper": "^1.0.0",
    "@sparta.global.helpers/svg-helper": "^2.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.global.helpers/picture-helper": "^1.0.0",
    "@sparta.global.vendors/jquery": "^3.2.1",
    "@sparta.global.vendors/lodash": "^4.17.21"
  },
  "stores": []
};

/**
 * Implementation of the routes for the site-specific-dme-chapter-container-module module.
 * @copyright 2018-5-11
 * @since 5/11/2018, 9:43:53 AM
 * @author Renzo Gaspary
 * @file
 */

const routes = {
  default: {
    page: '1.000',
    chapter: '0',
    layout: 'splash-page-layout',
    endpoints: {
      submit: '/apply-now-services/home-loans/rest/dma/personal-information/v1'
    },
    modules: {
      'dma-tag-manager-module': {
        bactm_auth: [],
        bactm_unAuth: [0, {
          isApp: true,
          chat: {
            site_id: 37000282
          }
        }]
      }
    }
  },
  splash: {
    page: '8.000',
    layout: 'splash-page-layout',
    modules: {
      'dma-tag-manager-module': {
        bactm_auth: [],
        bactm_unAuth: [0, {
          isApp: true,
          chat: {
            site_id: 37000282
          }
        }]
      }
    }
  },
  landing: {
    page: '8.001',
    chapter: '0',
    layout: 'chapter-section-layout',
    endpoints: {
      init: '/apply-now-services/home-loans/rest/dma/landing/v1'
    },
    modules: {
      'forms-module': {
        partial: 'tiles',
        dataSource: 'dmeLandingPage'
      },
      'dma-tag-manager-module': {
        bactm_auth: [],
        bactm_unAuth: [0, {
          isApp: true,
          chat: {
            site_id: 37000282
          }
        }]
      }
    }
  },
  'off-ramp': {
    chapter: '0',
    layout: 'chapter-section-layout',
    endpoints: {
      init: '/apply-now-services/home-loans/rest/dma/off-ramp/v1',
      submit: '/apply-now-services/home-loans/rest/dma/off-ramp/v1',
      'go-back': '/apply-now-services/home-loans/rest/go-back-action/off-ramp/v1'
    },
    modules: {
      'off-ramp-module': 'default',
      'dma-tag-manager-module': {
        _comment: 'we will need to handle dmaOR_ORCode as a variable dependent on Offramp',
        bactm_auth: [12, {
          isApp: true,
          authenticated: true,
          segmentValues: ['dmaOR_ORCode'],
          chat: {
            site_id: 37000351
          }
        }],
        bactm_unAuth: [12, {
          isApp: true,
          segmentValues: ['dmaOR_ORCode'],
          chat: {
            site_id: 37000351
          }
        }]
      }
    }
  }
};
Object.keys(routes).forEach(routeName => {
  workflowUtility.dispatch(workflowUtility.actions.initModule(null, {}, {}, [routeName], routes[routeName]));
});
workflowUtility.dispatch(workflowUtility.actions.startApp());

/**
 * Called when one of the chapter links has been clicked.
 * @param {Object} data Backend data for this route.
 * @param {String} mount A string containing the chapter number or null
 * @param {Function} dispatch Redux dispatch
 * @returns {void}
 */
function submit(data, mount, dispatch) {
  dispatch(workflowUtility.actions.goToChapter(mount));
}

/**
 * Updates the click handler on the individual chapter buttons in the menu.
 * @param {String} chapter The chapter number we're currently displaying
 * @param {Object} dataReceived Backend data for this route
 * @param {Function} dispatch Redux dispatch
 * @returns {void}
 */
function updateClickableItems(chapter, dataReceived, dispatch) {
  // after chapter 7, switching chapters should be disabled
  if (chapter && chapter.includes('7')) {
    $('ol.chapter-list .completed-chapter button').addClass('spa-btn--disabled disabled-chapter').attr('disabled', 'disabled');
    return;
  }
  $('ol.chapter-list .completed-chapter button').click(e => {
    const $this = $(e.currentTarget).closest('.completed-chapter');
    if (dataReceived.clickableChapters && dataReceived.clickableChapters.length) {
      $this.addClass('clickable-chapter').addClass('click-bound');
      submit(dataReceived, $this.attr('data-mount'), dispatch);
    }
  });
}

/**
 * Chapter container sparta module class
 */
class ChapterContainerModuleJS extends Module {
  /**
   * Constructs a new chapter container module
   * @param {Object} options Sparta options
   * @param {Object} context Sparta context
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
    this.target = document.querySelector('.chapter-container-module');
    this.currentChapter = 0;
  }

  /**
   * Initializes the chapter container route, called on page load.
   * @returns {void}
   */
  init() {
    const onMount = this.onMount.bind(this);
    onMount.oncePerRoute = true;
    workflowUtility.dispatch(workflowUtility.actions.initModule($(this.target), {
      onMount
    }));
    workflowUtility.subscribeToStore(this.updateTheCurrentChapter.bind(this));
  }

  /**
   * Workflow lifecycle method - calls after router partials have been run and added to the DOM.
   * @param {$} $module JQuery reference to the module element.
   * @param {Function} dispatch Dispatches an action to the store.
   * @param {Function} getState Gets the state from the store.
   * @returns {void}
   */
  onMount($module, dispatch, getState) {
    const module = $module[0];
    const chapterListToggleButton = module.querySelector('#toggleMenuList');
    const chapterListWrapper = module.querySelector('.chapter-list-wrapper');
    const state = getState();
    const {
      dataReceived
    } = state;
    const {
      closeMenuButtonCopy: closeCopy,
      menuButton: {
        label: openCopy
      }
    } = this.settings.copy.chapterList;
    $(chapterListToggleButton).unbind('click').click(() => {
      chapterListToggleButton.classList.toggle('close');
      if (chapterListWrapper.classList.contains('closed')) {
        chapterListWrapper.classList.add('opened');
        chapterListWrapper.classList.remove('closed');
        chapterListToggleButton.querySelector('.spa-circle-btn-label').innerHTML = closeCopy;
      } else {
        chapterListWrapper.classList.add('closed');
        chapterListWrapper.classList.remove('opened');
        chapterListToggleButton.querySelector('.spa-circle-btn-label').innerHTML = openCopy;
      }
    });
    const {
      chapter
    } = state.currentRoute;
    updateClickableItems(chapter, dataReceived, dispatch);
  }

  /**
   * Updates the current chapter in the hamburger menu
   * @param {Object} state Redux state
   * @returns {void}
   */
  updateTheCurrentChapter(state) {
    // ignore if current route is empty
    if (!state.currentRoute) return;

    // Update the chapter title
    this.updateChapterTitle(state);
    if (!state.currentRoute.chapter) return;
    // ignore if thats the same chapter
    if (this.currentChapter === state.currentRoute.chapter) return;

    // if the chapter is 7a (approved) or 7b (referred) then hide the hamburger
    if (state.currentRoute.chapter === '7a' || state.currentRoute.chapter === '0') {
      $('#chapterListHamburger').hide();
    } else {
      $('#chapterListHamburger').show();
    }
    this.currentChapter = state.currentRoute.chapter;
    // with index 0
    const currentChapter = this.currentChapter === '7a' ? this.currentChapter : parseInt(this.currentChapter, 10);
    const chapterList = this.target.querySelector('.chapter-list');
    const chapterListItems = chapterList.children;
    const chapterListLength = chapterListItems.length;
    for (let i = 1; i <= chapterListLength; i += 1) {
      const chapterListItem = chapterListItems[i - 1];
      // remove all the old classes
      chapterListItem.classList.remove('completed-chapter');
      chapterListItem.classList.remove('current-chapter');
      if (i < currentChapter) {
        // mark chapters as completed
        chapterListItem.classList.add('completed-chapter');
        chapterListItem.getElementsByClassName('chapter-name-link')[0].classList.remove('hide');
        chapterListItem.getElementsByClassName('chapter-name')[0].classList.add('hide');
        chapterListItem.getElementsByClassName('success-icon')[0].classList.remove('hide');
        chapterListItem.getElementsByClassName('inactive-number-icon')[0].classList.add('hide');
        chapterListItem.getElementsByClassName('active-number-icon')[0].classList.add('hide');
      } else if (i === currentChapter) {
        // mark as current-chapter
        if (currentChapter !== 0) {
          chapterListItem.classList.add('current-chapter');
          chapterListItem.getElementsByClassName('chapter-name-link')[0].classList.add('hide');
          chapterListItem.getElementsByClassName('chapter-name')[0].classList.remove('hide');
          chapterListItem.getElementsByClassName('inactive-number-icon')[0].classList.add('hide');
          chapterListItem.getElementsByClassName('success-icon')[0].classList.add('hide');
          chapterListItem.getElementsByClassName('active-number-icon')[0].classList.remove('hide');
          chapterListItem.getElementsByClassName('chapter-in-progress-copy')[0].classList.remove('hide');
          chapterListItem.getElementsByClassName('chapter-not-completed-copy')[0].classList.add('hide');
        }
      } else {
        // mark as not completed
        chapterListItem.getElementsByClassName('chapter-name-link')[0].classList.add('hide');
        chapterListItem.getElementsByClassName('chapter-name')[0].classList.remove('hide');
        chapterListItem.getElementsByClassName('inactive-number-icon')[0].classList.remove('hide');
        chapterListItem.getElementsByClassName('success-icon')[0].classList.add('hide');
        chapterListItem.getElementsByClassName('active-number-icon')[0].classList.add('hide');
        chapterListItem.getElementsByClassName('chapter-in-progress-copy')[0].classList.add('hide');
        chapterListItem.getElementsByClassName('chapter-not-completed-copy')[0].classList.remove('hide');
      }
      if (!chapterListItem.classList.contains('completed-chapter')) {
        chapterListItem.classList.remove('clickable-chapter');
      }
    }
  }

  /**
   * Updates the chapter title
   * @param {Object} state Redux state
   * @returns {void}
   */
  updateChapterTitle(state) {
    const {
      chapter,
      routeName
    } = state.currentRoute;
    const {
      chapters
    } = this.settings.copy.chapterList;
    const {
      specialRouteTitles
    } = this.settings.copy;
    let {
      name
    } = _.find(chapters, c => c.number === chapter) || {};
    if (name == null) name = specialRouteTitles[routeName];
    $('#titleModule h1').html(name || '&nbsp;');
  }
}
/* istanbul ignore next */

registerModuleClass({
  moduleClass: ChapterContainerModuleJS,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { ChapterContainerModuleJS as default, moduleConfig };
